/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    if (
      (metaData === "getdropdownbarcodedata") |
      (metaData === "getdropdownbillerdata")
    ) {
      return api
        .post(`/org/${metaData}`, payload)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error));
    } else {
      return api
        .post(`/masters/${metaData}`)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error));
    }
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export function loadBillStatusMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPurchaseInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/getpurchaseinvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPurchaseBarcodeDetails(salesInvoiceList) {
  return await api
    .post(`/org/getpurchasebarcodedata`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPurchasePrintDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/getpurchaseinvoicereceipt`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadLedgerStatmentDetails(partyLedger) {
  return await api
    .post(`/org/getpartyledgerreport`, partyLedger)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartyWiseOutstandingReportDetails(partyLedger) {
  return await api
    .post(`/org/getpartywiseoutstanding`, partyLedger)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadDashboardTransactionsDetails(transactionsList) {
  return await api
    .post(`/org/getdashboardtransaction`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadTotalSalesDetails(transactionsList) {
  return await api
    .post(`/org/totalsalespi`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalPaidDetails(transactionsList) {
  return await api
    .post(`/org/totalgetpaidpi`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalUnPaidDetails(transactionsList) {
  return await api
    .post(`/org/totalgetunpaidpi`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPurchaseInvoiceDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/createpurchaseinvoice`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//party vendor address
export async function loadPartyVendorAddressDetails(addressList) {
  return await api
    .post(`/org/getpartyorvendoraddress`, addressList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartyVendorAddressDetails(partyAddress) {
  return await api
    .post(`/org/addpartyorvendorshippingaddress`, partyAddress)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesCategoryDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/getpartycategory`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesCategoryDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/createpartycategory`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updatePurchaseInvoiceDetails(salesInvoiceList) {
  return await api
    .put(`/org/updatepurchaseinvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePurchaseInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/deletepurchaseinvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesTransactionDetails(purchaseInvoiceList) {
  return await api
    .post(`/org/getpartytransaction`, purchaseInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//stock report

export async function loadManageOrganizationDetails(stockDetails) {
  return await api
    .post(`/org/getorganizationmanage`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
//barcode report

export async function loadStockSummaryReportDetails(stockDetails) {
  return await api
    .post(`/org/getstocksummaryreportpagination`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadTicketingDetailsReport(stockDetails) {
  return await api
    .post(`/org/admingettiketing`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//profit report
export async function loadProfitReportDetails(stockDetails) {
  return await api
    .post(`/org/getprofitandlossreport`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//item report

export async function loadItemsQuantityReportDetails(stockDetails) {
  return await api
    .post(`/org/getitemqtyreport`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//sales items report

export async function loadSalesItemsQuantityReportDetails(stockDetails) {
  return await api
    .post(`/org/getsalesitemwisereport`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
//sales report

export async function loadSalesFiltersReportDetails(stockDetails) {
  return await api
    .post(`/org/getsalesreport`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//sales summary report

export async function loadSalesSummaryReportDetails(stockDetails) {
  return await api
    .post(`/org/getsalessummaryreport`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
//purchase summary report

export async function loadPurchaseSummaryReportDetails(stockDetails) {
  return await api
    .post(`/org/getpurchasesummaryreport`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//sales return report

export async function loadSalesReturnReportDetails(stockDetails) {
  return await api
    .post(`/org/getsalesreturnwise`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTicketingReplyDetails(stockDetails) {
  return await api
    .post(`/org/getadmintiketing`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
//sales return item report

export async function loadSalesReturnItemsReportDetails(stockDetails) {
  return await api
    .post(`/org/getsalesreturnitemwise`, stockDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadPurchaseInvoiceDetails,
  loadPurchaseBarcodeDetails,
  loadPurchasePrintDetails,
  loadStockSummaryReportDetails,
  loadTicketingDetailsReport,
  loadManageOrganizationDetails,
  loadProfitReportDetails,
  loadLedgerStatmentDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadPartiesTransactionDetails,
  createPurchaseInvoiceDetails,
  loadRecordsMetaData,
   loadTicketingReplyDetails,
  loadItemsQuantityReportDetails,
  loadSalesItemsQuantityReportDetails,
  loadSalesFiltersReportDetails,
  loadSalesSummaryReportDetails,
  loadBillStatusMetaData,
  loadPurchaseSummaryReportDetails,
  loadSalesReturnReportDetails,
  loadSalesReturnItemsReportDetails,
  updatePurchaseInvoiceDetails,
  deletePurchaseInvoiceDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadDashboardTransactionsDetails,
  loadTotalSalesDetails,
  loadTotalPaidDetails,
  loadTotalUnPaidDetails,
  loadPartyWiseOutstandingReportDetails,
};

export default remotes;
